// Turns plain video links (YouTube, Vimeo, Dailymotion) inside article HTML
// into responsive embedded players.

const VIDEO_URL_RE = /https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/[^\s<"')]+|youtu\.be\/[^\s<"')]+|vimeo\.com\/[^\s<"')]+|dailymotion\.com\/[^\s<"')]+|dai\.ly\/[^\s<"')]+)/i;

// Returns the player URL for a supported video link, or null.
export function videoEmbedUrl(rawUrl) {
  if (!rawUrl) return null;
  const url = rawUrl.trim().replace(/[.,;)]+$/, "");
  let m;

  m = url.match(/youtu\.be\/([\w-]{6,})/i);
  if (m) return `https://www.youtube.com/embed/${m[1]}${startParam(url)}`;

  m = url.match(/youtube\.com\/(?:watch\?(?:[^#]*&)?v=|v\/|embed\/|shorts\/|live\/)([\w-]{6,})/i);
  if (m) return `https://www.youtube.com/embed/${m[1]}${startParam(url)}`;

  m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;

  m = url.match(/dailymotion\.com\/video\/([\w]+)/i) || url.match(/dai\.ly\/([\w]+)/i);
  if (m) return `https://www.dailymotion.com/embed/video/${m[1]}`;

  return null;
}

function startParam(url) {
  const m = url.match(/[?&](?:t|start)=(\d+)/);
  return m ? `?start=${m[1]}` : "";
}

function iframeHtml(src) {
  return `<div class="video-embed"><iframe src="${src}" title="Video" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`;
}

export function embedVideosInHtml(html) {
  if (!html || !VIDEO_URL_RE.test(html)) return html;

  // 1. Anchors pointing at a video → player
  let out = html.replace(/<a\b[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, (full, href) => {
    const src = videoEmbedUrl(href);
    return src ? iframeHtml(src) : full;
  });

  // 2. Bare video URLs in text (not inside an attribute)
  out = out.replace(/(^|[\s>])(https?:\/\/[^\s<"']+)/gi, (full, prefix, url) => {
    const src = videoEmbedUrl(url);
    return src ? `${prefix}${iframeHtml(src)}` : full;
  });

  // 3. Unwrap paragraphs that only hold a player (invalid div-in-p nesting)
  out = out.replace(/<p[^>]*>\s*((?:<div class="video-embed">[\s\S]*?<\/div>\s*)+)<\/p>/gi, "$1");

  return out;
}
